import { render, staticRenderFns } from "./BookingChat.vue?vue&type=template&id=f3fa1a72&scoped=true"
import script from "./BookingChat.vue?vue&type=script&lang=js"
export * from "./BookingChat.vue?vue&type=script&lang=js"
import style0 from "./BookingChat.vue?vue&type=style&index=0&id=f3fa1a72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3fa1a72",
  null
  
)

export default component.exports